/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableUpdatePackageInfo
 */
export interface AvailableUpdatePackageInfo {
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseNotesSummary?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseNotesUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    releaseDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    eulaUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableUpdatePackageInfo
     */
    $type?: AvailableUpdatePackageInfoTypeEnum;
}


/**
 * @export
 */
export const AvailableUpdatePackageInfoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoAvailableUpdatePackageInfoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.AvailableUpdatePackageInfo, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AvailableUpdatePackageInfoTypeEnum = typeof AvailableUpdatePackageInfoTypeEnum[keyof typeof AvailableUpdatePackageInfoTypeEnum];


/**
 * Check if a given object implements the AvailableUpdatePackageInfo interface.
 */
export function instanceOfAvailableUpdatePackageInfo(value?: unknown): value is AvailableUpdatePackageInfo {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AvailableUpdatePackageInfoTypeEnum)[0];
}

export function AvailableUpdatePackageInfoFromJSON(json: any): AvailableUpdatePackageInfo {
    return AvailableUpdatePackageInfoFromJSONTyped(json, false);
}

export function AvailableUpdatePackageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableUpdatePackageInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
        'releaseNotesSummary': !exists(json, 'releaseNotesSummary') ? undefined : json['releaseNotesSummary'],
        'releaseNotesUri': !exists(json, 'releaseNotesUri') ? undefined : json['releaseNotesUri'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'eulaUri': !exists(json, 'eulaUri') ? undefined : json['eulaUri'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AvailableUpdatePackageInfoToJSON(value?: AvailableUpdatePackageInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'version': value.version,
        'releaseNotesSummary': value.releaseNotesSummary,
        'releaseNotesUri': value.releaseNotesUri,
        'releaseDate': value.releaseDate,
        'eulaUri': value.eulaUri,
        '$type': value.$type,
    });
}

